export default {"src":"/_next/static/media/upoading.47fc8b11.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};